
import React, { Component } from 'react';
import {FormContext, FormProvider} from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import {Button, Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import ClientContractForm from "./ContractForm";


export default class EditContractDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handlePostSave = () => {
    const { listContext } = this.props;
    this.toggleOpen();
    listContext.reload();
  };

  render() {
    const { isOpen } = this.state;
    const { item } = this.props;

    return (
      <>
        <Button variant={'outlined'} onClick={() => this.toggleOpen()}>
          Посмотреть
        </Button>

        <Dialog open={isOpen} onClose={() => this.toggleOpen()}>
          <DialogTitle>Договор {item.number}</DialogTitle>
          <DialogContent className={'w-500'}>
            <FormProvider
              url={item.meta.url}
              postSave={(item) => this.handlePostSave(item)}
              postSaveMessage={'Договор обновлен'}
              item={item}
            >
              <FormContext.Consumer>
              {context => {
                const { loading } = context;
                return (
                  <React.Fragment>
                    <ClientContractForm />

                    <div className={'mt-30 mb-30'}>
                      <YellowButton
                        size={'large'}
                        onClick={(e) => context.handleSubmit(e)}
                        disabled={loading}
                      >
                        Обновить договор
                      </YellowButton>

                    </div>
                  </React.Fragment>
                )
              }}
              </FormContext.Consumer>
            </FormProvider>
          </DialogContent>
        </Dialog>
      </>
    )
  }
}
